import { IconS24Pen24 } from '@is24/cosma-ui-icons';
import { ButtonRounded } from 'is24-corecss';
import { useState } from 'react';
import { AddressModifyForm } from './AddressModifyForm';
import { RenderSection } from './OverviewTab';
import { useGetProductsStatus } from '@/apiHooks/productsStatus.hook';
import { useGetInsuranceDetails } from '@/apiHooks/insurance.hook';
import { useIntl } from '@/i18n/hooks/useIntl';
import { InsuranceServiceName } from '@/@types/insurance';

export const AragUserDetailsSection = ({ serviceName }: { serviceName: InsuranceServiceName }) => {
  const [modificationForm, setModificationForm] = useState(false);
  const { areProductsRefetching } = useGetProductsStatus();
  const { insuranceDetails, isInsuranceDetailsSuccess } = useGetInsuranceDetails(true);
  const { t } = useIntl();

  if (!modificationForm) {
    return (
      <RenderSection
        title={t({
          id: `common.aragModal.form.address`,
          defaultMessage: '',
        })}
        content={
          <>
            <p>
              {insuranceDetails?.user?.firstName} {insuranceDetails?.user?.lastName}
            </p>
            <p>
              {insuranceDetails?.address?.street} {insuranceDetails?.address?.houseNumber}
            </p>
            <p>
              {insuranceDetails?.address?.postalCode} {insuranceDetails?.address?.city}
            </p>
            <ButtonRounded
              onClick={() => setModificationForm(true)}
              disabled={!isInsuranceDetailsSuccess}
              className={'margin-top-xs display-flex '}
              variant='outlineStrong'
              leftIcon={<IconS24Pen24 height={16} width={16} className='margin-right-xs' />}
              size='small'
              label={t({
                id: `common.aragModal.form.edit`,
                defaultMessage: '',
              })}
            />
          </>
        }
      />
    );
  }

  if (!insuranceDetails) return null;

  return (
    <AddressModifyForm
      serviceName={serviceName}
      isLoading={areProductsRefetching}
      close={() => setModificationForm(false)}
      insuranceDetails={insuranceDetails}
      setModificationForm={setModificationForm}
    />
  );
};
